import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import { Company } from '@common/auth/company';
import { LoanProduct } from '@app_modules/loan-products/loan-product';

export interface FetchProductResponse extends BackendResponse {
   html: string;
}


const htmlQueryKeys = {
  demoHtml: (reportId: string) => ['demo-uw-html', reportId] as const,
};

export function useMyHtml(report_id: string) {
  return useQuery({
    // queryKey: [`my-html-${report_id}`],
    queryKey: htmlQueryKeys.demoHtml(report_id),
    queryFn: () => fetchHtml(report_id),
  });
}

function fetchHtml(report_id: string): Promise<FetchProductResponse> {
  return apiClient.get(`${report_id}/demo-uw-html`).then(response => response.data);
}
